import { createAsyncThunk } from '@reduxjs/toolkit';

import { IEstelamBimehMarkaziQuery } from 'Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Queries/IEstelamBimehMarkaziQuery';
import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getEstelamBimehMarkazi = createAsyncThunk(
  'BimehNameh/estelamBimehMarkazi',
  async (query: IEstelamBimehMarkaziQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehMarkazi.EstelamBimehMarkazi}`,
      params: query,
    });
  }
);
